import { http } from '@/api/http';

export interface DashboardSnapshot {
  regularity_30d: Array<{ day: string; attempts: number }>;
  cards_backlog: number;
  weaknesses_top5: Array<{ theme: string; fails: number }>;
}

export const parentApi = {
  login: (pin: string) =>
    http.post<{ ok: true }>('/api/v1/parent/login', { pin }),
  logout: () => http.post<void>('/api/v1/parent/logout', {}),
  dashboard: () => http.get<DashboardSnapshot>('/api/v1/parent/dashboard'),
};
